import { Skeleton } from "@/components/ui/skeleton";

export default function TopupDetailsSkeleton() {
  return (
    <div className="mt-2 grid grid-cols-1 gap-6 md:grid-cols-[2fr_1fr]">
      <div className="space-y-6">
        {[1].map((route) => (
          <section key={route} className="flex flex-col gap-2">
            <Skeleton className="h-5 w-40" />
            <div className="overflow-hidden rounded-2xl bg-card shadow-xl">
              <div className="grid h-10 grid-cols-[1.5fr_auto_1fr] items-center gap-2 bg-primary px-4 py-2">
                <Skeleton className="h-4 w-28" />
                <Skeleton className="mx-auto h-4 w-8" />
                <Skeleton className="ml-auto h-4 w-10" />
              </div>
              <div className="flex flex-col gap-4 px-4 pt-3 pb-4">
                {[1, 2].map((ticket) => (
                  <div
                    key={ticket}
                    className="grid grid-cols-[1.5fr_auto_1fr] items-center gap-2"
                  >
                    <div className="flex items-center gap-3">
                      <Skeleton className="h-4 w-6" />
                      <Skeleton className="h-4 w-32" />
                    </div>
                    <Skeleton className="mx-auto h-4 w-6" />
                    <Skeleton className="ml-auto h-4 w-16" />
                  </div>
                ))}
                <Skeleton className="h-px w-full" />
                <div className="flex items-center justify-between">
                  <Skeleton className="h-4 w-12" />
                  <Skeleton className="h-5 w-20" />
                </div>
              </div>
            </div>
          </section>
        ))}
      </div>
      <div className="hidden md:block">
        <div className="rounded-2xl bg-card px-4 py-6 shadow-xl">
          <div className="flex items-center justify-between pb-8">
            <Skeleton className="h-4 w-12" />
            <Skeleton className="h-4 w-24" />
          </div>
          <Skeleton className="h-10 w-full rounded-md" />
        </div>
      </div>
    </div>
  );
}